import {HeaderMall9} from "../../../../publicComponent/Header";
import FooterMall9 from "../../../../publicComponent/Footer/FooterMall9";
import Category from "./components/Category";
import Products from "./components/Products";
import Coupon from "./components/Coupon";
import HomeContext, {HomeController, useHomeContext} from "../../../../reducer/moduleReducer/home";
import {useEffect, useState} from "react";
import {useNavigateTo} from "../../../../hooks/useNavigateTo";
import {mediaMatch} from "../../../../utils";

function Banner() {
  const { getBannerList } = HomeController();
  const { state } = useHomeContext();
  const { bannerLoading, bannerList } = state;
  
  useEffect(() => {
    getBannerList();
  }, []);
  
  return (
    <div className="mdmax:w-[94%] mdmax:my-0 mdmax:mx-auto mdmax:pt-[71px] mdmax:hidden">
      {
        bannerList.length > 0
          ? <img src={bannerList[0].mainPicView}
                 style={{ width: '100%'}}/>
          : <div style={{ visibility: 'hidden', height: 900 }}>
          
          </div>
      }
    </div>
  );
}


function HomeWrap() {
  const { getBannerList, getMidBanner } = HomeController();
  const { state } = useHomeContext();
  const [keyword, setKeyword] = useState('');
  const navigateTo = useNavigateTo();
  const isMdmax = mediaMatch.isMdmax;
  
  const inputHandle = (e) => {
    setKeyword(e.target.value);
  };
  
  const inputKeyUp = (e) => {
    if (e.keyCode === 13) {
      navigateTo(`/searchGoodsPage?keyword=${keyword}`);
    }
  };
  
  useEffect(() => {
    getMidBanner();
  }, []);
  
  return (
    <>
      <Banner/>
      <div className="pt-[75px] px-[3%] relative md:hidden">
        <i className="iconfont icon-search absolute left-[24px] bottom-[10px]"></i>
        <input type="text"
               onChange={inputHandle}
               onKeyUp={inputKeyUp}
               className="w-[100%] bg-white rounded-[10px] py-[12px] px-[15px] text-[13px] pl-[40px]"/>
      </div>
      <Category/>
      {
        state.midBanner.length > 0 && state.midBanner[0].contentList && state.midBanner[0].contentList.length > 0 &&
        <img className="mdmax:hidden w-[100%]"
             src={state.midBanner[0].contentList[0].mainPicView}/>
      }
      <Products/>
      <Coupon/>
      <FooterMall9/>
    </>
  );
}

function Home(props) {
  return (
    <div className="mdmax:pb-[60px] bg-[#f4f4f6]">
      <HeaderMall9 absolute type={'home'}/>
      <HomeContext>
        <HomeWrap/>
      </HomeContext>
    </div>
  );
}

export default Home;
